import { Stack, Text, HStack, Heading, Box } from '@chakra-ui/react'
import { ScrollableContent } from '@!/Store/Home/components'
import { Content } from '@!/Store/Common/components/ScrollableList'
import { CircularProgressModal } from '@!/components/Modal'
import { isBlank } from '@!/Util'
import { IoTrashOutline } from 'react-icons/io5'

export const LatelyAccessList = ({ titles, isLoading, handleResetLog, gtmClick }) => {
  const sectionTitle = '最近チェックしたマンガ'

  return (
    <>
      <CircularProgressModal isOpen={isLoading} />
      <Stack gap={0} mx={4}>
        <HStack gap={0} mb={3} justifyContent="space-between">
          <Heading fontSize="md" as="h2" lineClamp={1}>
            {sectionTitle}
          </Heading>
          {!isBlank(titles) && (
            <HStack gap={0} as="button" onClick={handleResetLog} alignItems="center">
              <Text fontSize="xs" lineHeight="16px">
                履歴を全て削除
              </Text>
              <IoTrashOutline />
            </HStack>
          )}
        </HStack>
        {isBlank(titles) ? (
          <Text fontSize="xs" textAlign="center">
            最近チェックしたマンガはありません。
          </Text>
        ) : (
          <ScrollableContent>
            <Stack direction="row" gap={0}>
              {titles.map((title) => (
                <Box key={`${sectionTitle}-${title.id}`} mr={3}>
                  <Content contentId={title.id} contentName={title.name} imageUrl={title.image_url} gtmClick={gtmClick} />
                </Box>
              ))}
            </Stack>
          </ScrollableContent>
        )}
      </Stack>
    </>
  )
}
